import { S1CloudProviderData } from 'common/graphqlTypes';
import { CloudProviderConfiguration, CloudProviderField } from './types';
import EndpointCloudProviderField from './EndpointCloudProviderField';

import './EndpointCloudProviderSection.scss';

export type EndpointCloudProviderSectionProps = {
  sectionConfiguration: CloudProviderConfiguration;
  s1CloudProvidersData: S1CloudProviderData;
};

/**
 * This component displays endpoint's cloud providers section.
 *
 * @prop sectionConfiguration section name, icon & list of section's fields configuration.
 * @prop s1CloudProvidersData sections cloud provider data.
 */
function EndpointCloudProviderSection({
  sectionConfiguration,
  s1CloudProvidersData,
}: EndpointCloudProviderSectionProps): JSX.Element {
  const createEndpointCloudProviderSectionField = (cloudProviderField: CloudProviderField): JSX.Element => (
    <div key={`${sectionConfiguration.title}_${cloudProviderField.key}`}>
      <EndpointCloudProviderField cloudProviderField={cloudProviderField} s1CloudProvidersData={s1CloudProvidersData} />
    </div>
  );

  return (
    <div className="EndpointCloudProviderSection">
      <div className="EndpointCloudProviderSection__Header">
        <img
          className="EndpointCloudProviderSection__HeaderImage"
          src={sectionConfiguration.image}
          alt={sectionConfiguration.title}
        />
        {sectionConfiguration.title}
      </div>
      {sectionConfiguration.fields.map((cloudProviderField) =>
        createEndpointCloudProviderSectionField(cloudProviderField),
      )}
    </div>
  );
}

export default EndpointCloudProviderSection;
